import priority from './task-priority/taskPriority';
import event from './task-event/taskEvent';
import quickButtons from './task-quick-buttons/taskQuickButtons';
import quickButtonsLegacy from './task-quick-buttons-legacy/taskQuickButtonsLegacy';
import taskSlim from './task-slim/taskSlim';
import storyTasks from './story-tasks/storyTasks';
import taskForm from './task-form/taskForm';
import deleteTasks from './delete-tasks/deleteTasks';
import taskCreatedBy from './task-created-by/taskCreatedBy';
import taskModalv2 from './task-modal/taskModalv2';

const toLoad = [
  priority,
  event,
  quickButtons,
  quickButtonsLegacy,
  taskSlim,
  storyTasks,
  taskForm,
  deleteTasks,
  taskCreatedBy,
  taskModalv2
];

export default function (ngModule) {
  toLoad.forEach((fn) => fn(ngModule));
}
